export enum ActionCableSubscriptionStatus {
  UNINITIALIZED = 'uninitialized', // Default state
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  REJECTED = 'rejected',
}
